import EnumCommon from './EnumCommon';
class EntityType extends EnumCommon {
    labels() {
        return {
            [1]: 'models/entities.types.administration',
            [2]: 'models/entities.types.association',
            [3]: 'models/entities.types.region',
            [4]: 'models/entities.types.headquarter',
        };
    }
}
EntityType.NAME = 'EntityType';
EntityType.ADMINISTRATION = new EntityType(1);
EntityType.ASSOCIATION = new EntityType(2);
EntityType.REGION = new EntityType(3);
EntityType.HEADQUARTER = new EntityType(4);
export default EntityType;
